module.exports = __webpack_public_path__ + "img/SKMJ_work1.0e31f1d2.jpg";